"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentsPage = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const client_1 = require("@apollo/client");
const lodash_1 = require("lodash");
const AccountContext_1 = require("contexts/AccountContext");
const FormatPagination_1 = require("components/general/utility/FormatPagination");
const ProblemOrdersIcon_1 = require("components/ProblemOrdersIcon");
const ProblemOrdersRules_1 = require("components/Dashboard/SearchableOrders/ProblemOrdersRules");
const ErrorMessage_1 = require("components/Dashboard/SearchableOrders/ErrorMessage");
const EmptyState_1 = require("components/Dashboard/SearchableOrders/EmptyState");
const hooks_1 = require("@/domains/shipments/hooks");
const shipments_page_graphql_1 = require("./shipments-page.graphql");
const shipments_page_styles_1 = require("./shipments-page.styles");
const react_router_1 = require("react-router");
const queryParams_1 = __importDefault(require("components/general/queryParams/queryParams"));
const shipments_page_utils_1 = require("./shipments-page.utils");
const components_1 = require("@/domains/shipments/components");
const layout_1 = require("@/common/components/layout");
const components_2 = require("@/common/components");
const perPage = 20;
const ISSUE_FILTERS = [
    { label: 'All', value: 'ALL' },
    { label: 'Delivery Attempted', value: 'ShipmentDeliveryAttempted' },
    { label: 'Return to Sender', value: 'ShipmentReturnedToSender' },
    { label: 'Stalled in Fulfillment', value: 'FulfillmentStalled' },
    { label: 'Stalled in Transit', value: 'ShipmentStalled' }
];
const STATUS_FILTERS = [
    { label: 'All', value: 'ALL' },
    { label: 'Delivered', value: 'delivered' },
    { label: 'Out for Delivery', value: 'out_for_delivery' },
    { label: 'In Transit', value: 'in_transit' },
    { label: 'Pre Transit', value: 'pre_transit' },
    { label: 'Return to Sender', value: 'return_to_sender' },
    { label: 'Available for Pickup', value: 'available_for_pickup' },
    { label: 'Cancelled', value: 'cancelled' },
    {
        label: 'Bad Tracking Code Error',
        value: 'bad_tracking_code_error'
    },
    {
        label: 'Extended Carriers Not Enabled Error',
        value: 'extended_carriers_not_enabled_error'
    },
    {
        label: 'Carrier Missing Authentication Error',
        value: 'carrier_missing_authentication_error'
    },
    { label: 'Unknown', value: 'unknown' }
];
const FILTER_KEY_NAMES = {
    problemOrders: 'problemOrders',
    shipmentCarriers: 'shipmentCarriers',
    shipmentStatuses: 'shipmentStatuses'
};
function buildFilterLabel(label, values, choiceList) {
    var _a;
    if (values.length) {
        const issuesString = (_a = values === null || values === void 0 ? void 0 : values
        // don't show 'all' in filter tags
        .filter((value) => value !== 'ALL')) === null || _a === void 0 ? void 0 : _a.map((value) => {
            var _a;
            return (((_a = choiceList.find(({ value: filterValue }) => filterValue === value)) === null || _a === void 0 ? void 0 : _a.label) || 'error');
        }).join(', ');
        return `${label}: ${issuesString}`;
    }
    return '';
}
function computeFiltersChange(oldFilters, newFilters, choiceList) {
    let result = [];
    const decreaseFilterCount = !!newFilters && !!oldFilters && newFilters.length < oldFilters.length;
    if ((oldFilters === null || oldFilters === void 0 ? void 0 : oldFilters.includes('ALL')) && decreaseFilterCount) {
        // deselect 'ALL' if one of the filters was deselected while ALL was
        // selected
        result = newFilters.filter((filter) => filter !== 'ALL');
    }
    else if (newFilters === null || newFilters === void 0 ? void 0 : newFilters.includes('ALL')) {
        // If ALL was selected, mark all filters as selected
        result = choiceList.map(({ value }) => value);
    }
    else {
        // regular filter update
        result = newFilters;
    }
    return result;
}
// eslint-disable-next-line complexity
const ShipmentsPage = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const { fetchCarriers, carrierChoiceList, loading: fetchCarriersLoading } = (0, hooks_1.useCarriers)();
    const navigate = (0, react_router_1.useNavigate)();
    const [page, setPage] = (0, queryParams_1.default)('page', 1);
    const [showProblemOrderRules, setShowProblemOrderRules] = (0, react_1.useState)(false);
    const { mode, setMode } = (0, polaris_1.useSetIndexFiltersMode)();
    const [tabNames, setTabNames] = (0, react_1.useState)(['All']);
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(0);
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const deleteView = (index) => {
        const newItemStrings = [...tabNames];
        newItemStrings.splice(index, 1);
        setTabNames(newItemStrings);
        setSelectedTab(0);
    };
    const duplicateView = (name) => __awaiter(void 0, void 0, void 0, function* () {
        setTabNames([...tabNames, name]);
        setSelectedTab(tabNames.length);
        yield sleep(1);
        return true;
    });
    const tabs = tabNames.map((item, index) => ({
        content: item,
        index,
        id: `${item}-${index}`,
        isLocked: index === 0,
        actions: index === 0
            ? []
            : [
                {
                    type: 'rename',
                    onPrimaryAction: (value) => __awaiter(void 0, void 0, void 0, function* () {
                        const newItemsStrings = tabs.map((tab, idx) => {
                            if (idx === index) {
                                return value;
                            }
                            return tab.content;
                        });
                        yield sleep(1);
                        setTabNames(newItemsStrings);
                        return true;
                    })
                },
                {
                    type: 'duplicate',
                    onPrimaryAction: (value) => __awaiter(void 0, void 0, void 0, function* () {
                        yield sleep(1);
                        duplicateView(value);
                        return true;
                    })
                },
                {
                    type: 'edit'
                },
                {
                    type: 'delete',
                    onPrimaryAction: () => __awaiter(void 0, void 0, void 0, function* () {
                        yield sleep(1);
                        deleteView(index);
                        return true;
                    })
                }
            ]
    }));
    const [pagination, setPagination] = (0, react_1.useState)(() => ({
        pageCount: 0,
        label: '0/0',
        isPreviousDisabled: true,
        isNextDisabled: true
    }));
    const [shipmentsHaveIssues, setShipmentsHaveIssues] = (0, react_1.useState)(false);
    const [orderCount, setOrderCount] = (0, react_1.useState)(0);
    const [shipments, setShipments] = (0, react_1.useState)([]);
    const [problemOrderFilters, setProblemOrderFilters] = (0, queryParams_1.default)('problemOrderFilters', []);
    const [statusFilters, setStatusFilters] = (0, queryParams_1.default)('statusFilters', []);
    const [carrierFilters, setCarrierFilters] = (0, queryParams_1.default)('carrierFilters', []);
    const [getOrders, { loading, error }] = (0, client_1.useLazyQuery)(shipments_page_graphql_1.GET_SEARCHABLE_ORDERS, {
        onCompleted: ({ searchableOrder }) => {
            var _a;
            setOrderCount(searchableOrder.hits.length);
            // we only want to operate on these after fetch so that we don't compute
            // the order list and pagination on every render
            const shipmentList = searchableOrder.hits.reduce((acc, { document }) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                const baseShipmentRecord = {
                    orderId: document.id,
                    orderNumber: document.number,
                    orderName: document.name,
                    orderInsertedAt: document.inserted_at,
                    orderPlacedAt: document.placed_at,
                    orderFulfilledAt: document.fulfilled_at || null,
                    orderCustomer: document.customer
                        ? {
                            email: (_a = document.customer) === null || _a === void 0 ? void 0 : _a.email,
                            firstName: (_b = document.customer) === null || _b === void 0 ? void 0 : _b.first_name,
                            lastName: (_c = document.customer) === null || _c === void 0 ? void 0 : _c.last_name
                        }
                        : null,
                    orderShippingAddress: {
                        country: ((_d = document.shipping_address) === null || _d === void 0 ? void 0 : _d.country) || null,
                        province: ((_e = document.shipping_address) === null || _e === void 0 ? void 0 : _e.province) || null,
                        zip: ((_f = document.shipping_address) === null || _f === void 0 ? void 0 : _f.zip) || null
                    },
                    orderIssues: (_g = document.issues) !== null && _g !== void 0 ? _g : [],
                    orderLatestIssue: (0, shipments_page_utils_1.findLatestOrderIssue)((_h = document.issues) !== null && _h !== void 0 ? _h : []),
                    orderMalomoAttributed: document.malomo_attributed || false,
                    orderManagementUrl: document.order_management_url,
                    carrier: null,
                    carrierName: null,
                    carrierUrl: null,
                    carrierService: null,
                    status: null,
                    trackingCode: null,
                    estimatedDeliveryDate: null,
                    lastScannedAt: null
                };
                const entries = ((_j = document === null || document === void 0 ? void 0 : document.shipments) === null || _j === void 0 ? void 0 : _j.reduce((shipmentEntries, shipment) => {
                    return shipmentEntries.concat([
                        Object.assign(Object.assign({}, baseShipmentRecord), { carrier: shipment.carrier, carrierName: shipment.carrier_name, carrierUrl: shipment.carrier_url, carrierService: shipment.carrier_service || null, status: shipment.status, trackingCode: shipment.tracking_code, estimatedDeliveryDate: shipment.estimated_delivery_date, lastScannedAt: shipment.last_scanned_at })
                    ]);
                }, [])) || [baseShipmentRecord];
                const filteredEntries = entries.filter(({ status, carrier }) => {
                    const passesStatusFilter = (0, shipments_page_utils_1.passesFilterCheck)(statusFilters, status);
                    const passesCarrierFilter = (0, shipments_page_utils_1.passesFilterCheck)(carrierFilters, carrier);
                    return passesStatusFilter && passesCarrierFilter;
                });
                return acc.concat(filteredEntries);
            }, []);
            setShipments(shipmentList);
            setShipmentsHaveIssues(!!shipmentList.find((shipment) => shipment.orderIssues.length > 0));
            const total = (_a = searchableOrder.found) !== null && _a !== void 0 ? _a : 0;
            const pageCount = Math.ceil(total / perPage);
            const isPreviousDisabled = page === 1;
            const isNextDisabled = page === pageCount;
            const paginationLabel = (0, FormatPagination_1.formatPagination)(page, pageCount);
            setPagination({
                pageCount,
                label: paginationLabel,
                isPreviousDisabled,
                isNextDisabled
            });
        }
    });
    const [searchTerm, setSearchTerm] = (0, queryParams_1.default)('q', '');
    const [searchFieldValue, setSearchFieldValue] = (0, react_1.useState)(() => searchTerm);
    (0, react_1.useEffect)(() => {
        // fetch initial carrier list on page load
        fetchCarriers();
    }, []);
    (0, react_1.useEffect)(() => {
        if (!(account === null || account === void 0 ? void 0 : account.id)) {
            return;
        }
        getOrders({
            variables: {
                input: {
                    accountId: account.id,
                    page,
                    perPage,
                    q: searchTerm,
                    issues: problemOrderFilters.length ? problemOrderFilters : undefined,
                    shipmentStatuses: statusFilters.length ? statusFilters : undefined,
                    shipmentCarriers: carrierFilters.length ? carrierFilters : undefined
                }
            }
        });
        fetchCarriers();
    }, [
        account,
        page,
        searchTerm,
        carrierFilters,
        statusFilters,
        problemOrderFilters,
        getOrders
    ]);
    const handleSearch = (0, react_1.useCallback)((query) => {
        setPage(1);
        setSearchTerm(query);
    }, []);
    const debouncedHandleSearch = (0, react_1.useMemo)(() => (0, lodash_1.debounce)(handleSearch, 500), [handleSearch]);
    const onQueryChange = (0, react_1.useCallback)((query) => {
        setSearchFieldValue(query);
        debouncedHandleSearch(query);
    }, [debouncedHandleSearch]);
    const handleProblemOrdersSelected = (0, react_1.useCallback)((newFilters) => {
        const computedFilters = computeFiltersChange(problemOrderFilters, newFilters, ISSUE_FILTERS);
        setPage(1);
        setProblemOrderFilters(computedFilters);
    }, [problemOrderFilters]);
    const handleStatusesSelected = (0, react_1.useCallback)((newFilters) => {
        const computedFilters = computeFiltersChange(statusFilters, newFilters, STATUS_FILTERS);
        setPage(1);
        setStatusFilters(computedFilters);
    }, [statusFilters]);
    const handleCarriersSelected = (0, react_1.useCallback)((newFilters) => {
        const computedFilters = computeFiltersChange(carrierFilters, newFilters, carrierChoiceList);
        setPage(1);
        setCarrierFilters(computedFilters);
    }, [carrierFilters]);
    const onRowClick = (0, react_1.useCallback)((orderId) => {
        navigate(`/shipments/orders/${orderId}`);
    }, []);
    const handleReset = () => {
        setPage(1);
        setSearchTerm('');
        setSearchFieldValue('');
        setCarrierFilters([]);
        setStatusFilters([]);
        setProblemOrderFilters([]);
    };
    const filters = [
        {
            key: FILTER_KEY_NAMES.problemOrders,
            label: 'Problem Orders',
            filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: ISSUE_FILTERS, onChange: handleProblemOrdersSelected, selected: problemOrderFilters, title: 'Problem Orders', titleHidden: true })),
            shortcut: true
        },
        {
            key: FILTER_KEY_NAMES.shipmentStatuses,
            label: 'Status',
            filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: STATUS_FILTERS, onChange: handleStatusesSelected, selected: statusFilters, title: 'Status', titleHidden: true })),
            shortcut: true
        },
        {
            key: FILTER_KEY_NAMES.shipmentCarriers,
            label: 'Carrier',
            filter: (react_1.default.createElement(polaris_1.ChoiceList, { allowMultiple: true, choices: carrierChoiceList, onChange: handleCarriersSelected, selected: carrierFilters, title: 'Carrier', titleHidden: true })),
            shortcut: true
        }
    ];
    const appliedFilters = [];
    if (!(0, lodash_1.isEmpty)(problemOrderFilters)) {
        appliedFilters.push({
            key: FILTER_KEY_NAMES.problemOrders,
            label: buildFilterLabel('Problem Orders', problemOrderFilters, ISSUE_FILTERS),
            onRemove: () => handleProblemOrdersSelected([])
        });
    }
    if (!(0, lodash_1.isEmpty)(statusFilters)) {
        appliedFilters.push({
            key: FILTER_KEY_NAMES.shipmentStatuses,
            label: buildFilterLabel('Status', statusFilters, STATUS_FILTERS),
            onRemove: () => handleStatusesSelected([])
        });
    }
    if (!(0, lodash_1.isEmpty)(carrierFilters)) {
        appliedFilters.push({
            key: FILTER_KEY_NAMES.shipmentCarriers,
            label: buildFilterLabel('Carrier', carrierFilters, carrierChoiceList),
            onRemove: () => handleCarriersSelected([])
        });
    }
    const hasFilters = !(0, lodash_1.isEmpty)(problemOrderFilters) || !(0, lodash_1.isEmpty)(statusFilters) || !!searchTerm;
    const rowMarkup = shipments.map((shipment, index) => {
        var _a, _b, _c, _d, _e, _f;
        const customerFullName = (0, shipments_page_utils_1.formatCustomerName)(shipment.orderCustomer);
        const placedDate = shipment.orderPlacedAt
            ? (0, shipments_page_utils_1.formatDate)(shipment.orderPlacedAt * 1000) // order.placed_at comes from shopify and is stored in seconds, not μsec
            : (0, shipments_page_utils_1.formatDate)(shipment.orderInsertedAt);
        const fulfilledAt = (0, shipments_page_utils_1.formatOptionalDate)(shipment.orderFulfilledAt);
        const estimatedDeliveryAt = (0, shipments_page_utils_1.formatOptionalDate)(shipment.estimatedDeliveryDate);
        const lastScannedAt = (0, shipments_page_utils_1.formatOptionalDate)(shipment.lastScannedAt);
        const orderStatus = (_a = shipment.orderLatestIssue) === null || _a === void 0 ? void 0 : _a.rule_name;
        return (react_1.default.createElement(polaris_1.IndexTable.Row, { id: shipment.orderNumber, key: `${shipment.orderId}${index}`, position: index },
            react_1.default.createElement(polaris_1.IndexTable.Cell, null,
                react_1.default.createElement(polaris_1.Link, { onClick: () => onRowClick(shipment.orderId) },
                    react_1.default.createElement(polaris_1.Text, { as: 'span', fontWeight: 'bold' }, shipment.orderName || shipment.orderNumber))),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, shipmentsHaveIssues && !!((_b = shipment.orderIssues) === null || _b === void 0 ? void 0 : _b.length) && (react_1.default.createElement(components_2.PolarisIcon, { accessibilityLabel: 'Problem Order', iconStyle: 'problemOrders' }))),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, customerFullName),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)((_c = shipment.orderCustomer) === null || _c === void 0 ? void 0 : _c.email)),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null,
                react_1.default.createElement(components_1.ShipmentStatusBadge, { orderStatus: orderStatus, statusCode: shipment.status })),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)(shipment.carrierName, '-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)(shipment.carrierService, '-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null,
                react_1.default.createElement(polaris_1.Text, { alignment: 'start', as: 'span' }, shipment.carrierUrl && (react_1.default.createElement(polaris_1.Link, { target: '_blank', url: shipment.carrierUrl },
                    react_1.default.createElement(components_2.PolarisIcon, { iconStyle: 'externalLink' }))))),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)((_d = shipment.orderShippingAddress) === null || _d === void 0 ? void 0 : _d.country, '-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)((_e = shipment.orderShippingAddress) === null || _e === void 0 ? void 0 : _e.province, '-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)((_f = shipment.orderShippingAddress) === null || _f === void 0 ? void 0 : _f.zip, '-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)(shipment.trackingCode, '-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, shipments_page_utils_1.formatOptionalField)(placedDate, '-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, fulfilledAt),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, estimatedDeliveryAt),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, lastScannedAt),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null, shipment.orderMalomoAttributed ? (react_1.default.createElement(components_1.ShipmentStatusBadge, { statusCode: 'Malomo attributed' })) : ('-')),
            react_1.default.createElement(polaris_1.IndexTable.Cell, null,
                react_1.default.createElement(polaris_1.Text, { alignment: 'start', as: 'span' }, shipment.orderManagementUrl && (react_1.default.createElement(polaris_1.Link, { target: '_blank', url: shipment.orderManagementUrl },
                    react_1.default.createElement(components_2.PolarisIcon, { iconStyle: 'externalLink' })))))));
    });
    return (react_1.default.createElement(layout_1.PolarisPage, { fullWidth: true, secondaryActions: react_1.default.createElement(polaris_1.Button, { "aria-label": 'Problem Order Rules', icon: ProblemOrdersIcon_1.ProblemOrdersIcon, onClick: () => setShowProblemOrderRules(true) }, "Problem orders"), title: 'Shipments' },
        react_1.default.createElement(polaris_1.Layout, null,
            react_1.default.createElement(polaris_1.Layout.Section, null, renderShipmentsTable()))));
    function renderShipmentsTable() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(polaris_1.LegacyCard, null,
                react_1.default.createElement(ProblemOrdersRules_1.ProblemOrdersRules, { onHide: () => setShowProblemOrderRules(false), show: showProblemOrderRules }),
                react_1.default.createElement(polaris_1.IndexFilters, { appliedFilters: appliedFilters, canCreateNewView: false, cancelAction: {
                        onAction: handleReset,
                        disabled: false,
                        loading: false
                    }, filters: filters, loading: fetchCarriersLoading, mode: mode, onClearAll: handleReset, onQueryChange: onQueryChange, onQueryClear: () => onQueryChange(''), onSelect: setSelectedTab, queryValue: searchFieldValue, selected: selectedTab, setMode: setMode, tabs: tabs }),
                react_1.default.createElement(polaris_1.IndexTable, { emptyState: error ? (react_1.default.createElement(ErrorMessage_1.ErrorMessage, null)) : (react_1.default.createElement(EmptyState_1.EmptyState, { hasFilters: hasFilters, loading: loading })), headings: [
                        { title: 'Order' },
                        { title: '' },
                        { title: 'Customer' },
                        { title: 'Email' },
                        { title: 'Status' },
                        { title: 'Carrier' },
                        { title: 'Carrier Service' },
                        { title: 'Carrier URL' },
                        { title: 'Country' },
                        { title: 'State / Province' },
                        { title: 'Zip' },
                        { title: 'Tracking Code ' },
                        { title: 'Order Placed' },
                        { title: 'Order Fulfilled' },
                        { title: 'Estimated Delivery Date' },
                        { title: 'Last Scanned At' },
                        { title: 'Malomo Attributed' },
                        { title: 'Shopify Order URL' }
                    ], itemCount: orderCount, loading: loading, resourceName: { singular: 'shipment', plural: 'shipments' }, selectable: false }, rowMarkup)),
            orderCount > 0 && (react_1.default.createElement(shipments_page_styles_1.PaginationContainer, null,
                react_1.default.createElement(polaris_1.Pagination, { hasNext: !pagination.isNextDisabled, hasPrevious: !pagination.isPreviousDisabled, label: pagination.label, onNext: () => setPage(page + 1), onPrevious: () => setPage(page - 1) })))));
    }
};
exports.ShipmentsPage = ShipmentsPage;
